import React, { Component } from 'react'
import { compose } from 'redux'

import HeaderDropdown from './HeaderDropdown'
import { connectResource } from '../../../utils/resource'
import { withLDConsumer } from 'launchdarkly-react-client-sdk'
import { withAuth } from '@common/hooks/useAuth'


class HeaderDropdownContainer extends Component {
  state = {
    dropdownOpen: false,
  }

  componentDidMount() {
    if (!this.props.lenderSelect.data) {
      if (this.props.user.data?.email && this.props.lenderSelect.filters.email !== this.props.user.data.email) {
        this.props.lenderSelect.filter({ email: this.props.user.data.email })
      }
    }
  }

  toggle = () => {
    this.setState({
      dropdownOpen: !this.state.dropdownOpen,
    })
  }

  render() {
    const isSwitchAccountItem = this.props.lenderSelect.data && this.props.lenderSelect.data.length > 1
    const { auth, ...props } = this.props
    return <HeaderDropdown
      {...props}
      logout={auth.logout}
      dropdownOpen={this.state.dropdownOpen}
      toggle={this.toggle}
      isShowSwitchAccountItem={isSwitchAccountItem}
    />
  }
}

export default compose(
  withAuth,
  withLDConsumer(),
  connectResource({
    namespace: 'lenderSelect',
    endpoint: 'lender/lender-select-options',
    prefetch: false,
    list: true,
    apiVersion: 2,
    filters: {
      email: '',
    },
  })
)(HeaderDropdownContainer)
